if (!customElements.get('zereniyo-header')) {
  class ZereniyoHeader extends HTMLElement {
    connectedCallback() {
      this.mobileToggle = this.querySelector('.z-header__mobile-toggle');
      this.mobileNavigation = this.querySelector('.z-header__nav-row');
      this.stickyHeader = this.querySelector('[data-z-sticky-header]');
      this.categoryMenu = this.querySelector('[data-z-category-menu]');
      this.dropdownMenus = Array.from(this.querySelectorAll('.z-header__nav-dropdown'));

      this.onScroll = this.updateScrolledState.bind(this);
      this.onDocumentClick = this.handleDocumentClick.bind(this);
      this.onKeydown = this.handleKeydown.bind(this);
      this.onResize = this.handleResize.bind(this);

      this.mobileToggle?.addEventListener('click', () => this.toggleMobileNavigation());
      this.querySelectorAll('.z-header__nav a').forEach((link) => {
        link.addEventListener('click', () => this.closeMobileNavigation());
      });

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize, { passive: true });
      document.addEventListener('click', this.onDocumentClick);
      document.addEventListener('keydown', this.onKeydown);
      this.updateScrolledState();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
      document.removeEventListener('click', this.onDocumentClick);
      document.removeEventListener('keydown', this.onKeydown);
    }

    toggleMobileNavigation() {
      const isOpen = !this.mobileNavigation?.classList.contains('is-open');
      this.mobileNavigation?.classList.toggle('is-open', isOpen);
      this.mobileToggle?.setAttribute('aria-expanded', String(isOpen));
    }

    closeMobileNavigation() {
      this.mobileNavigation?.classList.remove('is-open');
      this.mobileToggle?.setAttribute('aria-expanded', 'false');
    }

    updateScrolledState() {
      this.stickyHeader?.classList.toggle('is-scrolled', window.scrollY > 88);
    }

    handleDocumentClick(event) {
      if (this.categoryMenu?.open && !this.categoryMenu.contains(event.target)) {
        this.categoryMenu.removeAttribute('open');
      }

      this.dropdownMenus.forEach((dropdown) => {
        if (dropdown.open && !dropdown.contains(event.target)) dropdown.removeAttribute('open');
      });
    }

    handleKeydown(event) {
      if (event.key !== 'Escape') return;

      this.categoryMenu?.removeAttribute('open');
      this.dropdownMenus.forEach((dropdown) => dropdown.removeAttribute('open'));
      this.closeMobileNavigation();
      this.mobileToggle?.focus();
    }

    handleResize() {
      if (window.innerWidth > 760) this.closeMobileNavigation();
    }
  }

  customElements.define('zereniyo-header', ZereniyoHeader);
}
